import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { jwtAuthService } from '../../services/jwtAuthService';
import ForcePasswordChange from '../auth/ForcePasswordChange';

interface PasswordChangeWrapperProps {
  children: React.ReactNode;
}

export const PasswordChangeWrapper: React.FC<PasswordChangeWrapperProps> = ({ children }) => {
  const [needsPasswordChange, setNeedsPasswordChange] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPasswordChangeRequired();
  }, []);

  const checkPasswordChangeRequired = () => {
    try {
      const user = jwtAuthService.getCurrentUser();

      if (user && user.force_password_change === true) {
        setNeedsPasswordChange(true);
      } else {
        setNeedsPasswordChange(false);
      }
    } catch (error) {
      console.error('Error checking password change status:', error);
      setNeedsPasswordChange(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChanged = () => {
    setNeedsPasswordChange(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (needsPasswordChange) {
    return <ForcePasswordChange onPasswordChanged={handlePasswordChanged} />;
  }

  return <>{children}</>;
};

export default PasswordChangeWrapper;
